import Card from '@/common/components/Card';
import React from 'react';
import { ButtonWrapper, SearchBar, Title } from '../../Refunds.styles';
import SelectInput from '@/common/components/SelectInput';
import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { REFUND_STATUSES } from '@/common/constants/refunds';

const RefundsSearchBar = ({ hook }) => {
	const {
		options: { marketsOptions },
	} = useCommonDataContext();

	return (
		<Card>
			<SearchBar>
				<div>
					<Title>EUROPEAN LEARNING AGENCY Sp. z o.o.</Title>
				</div>
				<div style={{ display: 'flex' }}>
					<SelectInput
						name='Markets'
						width={70}
						selectWidth={725}
						color={Colors.darkBlue}
						options={marketsOptions}
						setSelected={hook.setSelectedMarkets}
						selected={hook.selectedMarkets}
						multiple
					/>
					<SelectInput
						name='Status'
						width={70}
						selectWidth={400}
						color={Colors.darkBlue}
						options={REFUND_STATUSES}
						setSelected={hook.setSelectedStatus}
						selected={hook.selectedStatus}
					/>
				</div>
				<ButtonWrapper>
					<ActionButton defaultText='Search' onClick={() => hook.handleSearch()} />
				</ButtonWrapper>
			</SearchBar>
		</Card>
	);
};

export default RefundsSearchBar;
